import BatchBaseController from '../common/batch.base.controller'

class BatchallController extends BatchBaseController {

  /*@ngInject*/
  constructor(Auth, $state, User, Modal, BatchService, $translate, $stateParams, $scope, $location) {

    super(Auth, $state, User, BatchService, Modal, $translate, $stateParams, $location)

    this.id = 'batch.all'
    this.loading = true
    this.batches = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.searchText = '',
    this.User = User,
    this.branchId = this.User.getUser().branchId
    this.$location = $location;
    this.filterByValue = null;
    this.model.filterByAllBranch = false;
  }

  $onInit() {
    let pageId = this.$stateParams.page
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(batch) {
    this.$state.go('batch.edit', ({
      id: batch.batchSourceId,
    }))
  }

  delete(batch) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${batch.batchSource.name}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true
        this.Service.remove(batch.batchSourceId, this.branchId)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close()
            this.refresh()
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    // this.loading = true
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData()
  }

  loadData() {
    const searchObj = this.generateSearchObj();
    
    this.loading = true;
    this.Service.all(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total

        this.loading = false
        this.batches = data.results;
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
      })
  }
  toggleExpand(batch) {
    batch.expand = !batch.expand;
  }

  generateSearchObj() {
    return {
      branchId: this.branchId,
      queryText: '%' + this.searchText + '%',
      isQuery: false,
      filterByAllBranch: this.model.filterByAllBranch
    }
  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/'+this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  filterByBranch(value) {
    this.page = 1;
    this.filterByValue = this.filterByValue === value ? undefined : value;
    this.model.filterByAllBranch = this.filterByValue ? true : false;
    this.loadData();
  }
}

export default BatchallController;


// WEBPACK FOOTER //
// ./client/app/components/batch/all/batch.all.controller.js